import React from 'react';

import type { IntlShape } from 'react-intl-next';

import type { ADFEntity } from '@atlaskit/adf-utils/types';
import Image from '@atlaskit/image';
import { fg } from '@atlaskit/platform-feature-flags';
import type { HubElement } from '@atlassian/company-hub-common';
import {
	cardsHubElementThumbnail,
	cardsHubElementThumbnailDark,
} from '@atlassian/company-hub-common/assets';

import { CARDS_EXTENSION_KEY, CARDS_EXTENSION_TYPE } from '../../constants';
import { getCardsExtensionParameters } from '../cards-manifest';

import { messages } from './messages';

const getDefaultCardsNodeAdf = (intl: IntlShape): ADFEntity => {
	const { formatMessage } = intl;

	return {
		type: 'extension',
		attrs: {
			extensionKey: CARDS_EXTENSION_KEY,
			extensionType: CARDS_EXTENSION_TYPE,
			parameters: getCardsExtensionParameters({
				extensionTitle: formatMessage(messages.cardsTitle),
				isCardsV2GateEnabled: fg('company_hub_cards_v2'),
				isDynamicCardsAIDescriptionsEnabled: fg('company_hub_dynamic_cards_ai_descriptions'),
			}),
		},
	};
};
const thumbnailImage: React.ReactNode = (
	<Image src={cardsHubElementThumbnail} srcDark={cardsHubElementThumbnailDark} alt="" />
);

export const cardsHubElement: HubElement = {
	extensionKey: CARDS_EXTENSION_KEY,
	title: messages.cardsTitle,
	description: messages.cardsDescription,
	Image: thumbnailImage,
	getNodeAdf: getDefaultCardsNodeAdf,
};
